import DependencyInformation from './DependencyInformation';

export default DependencyInformation;
